import { render, staticRenderFns } from "./RateTiersCell.vue?vue&type=template&id=6312204e&scoped=true"
import script from "./RateTiersCell.vue?vue&type=script&lang=js"
export * from "./RateTiersCell.vue?vue&type=script&lang=js"
import style0 from "./RateTiersCell.vue?vue&type=style&index=0&id=6312204e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312204e",
  null
  
)

export default component.exports